import { render, staticRenderFns } from "./ListBusinessByService.vue?vue&type=template&id=cd5fdae2&lang=pug&"
import script from "./ListBusinessByService.vue?vue&type=script&lang=js&"
export * from "./ListBusinessByService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports